import { LocalForage } from '../../../../utils/LocalForage';

async function clearAppCachesAndReload(): Promise<void> {
  try {
    if (
      typeof navigator !== 'undefined' &&
      'serviceWorker' in navigator &&
      navigator.serviceWorker.getRegistrations
    ) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((reg) => reg.unregister()));
    }
  } catch {
    // Ignore — fall through to reload regardless.
  }

  try {
    if (typeof window !== 'undefined' && 'caches' in window) {
      const cacheKeys = await window.caches.keys();
      await Promise.all(cacheKeys.map((key) => window.caches.delete(key)));
    }
  } catch {
    // Ignore — fall through to reload regardless.
  }

  try {
    await LocalForage.clear();
  } catch {
    // Ignore — stale serialized query caches from the previous version
    // are best-effort; fall through to reload regardless.
  }

  window.location?.reload();
}

export default clearAppCachesAndReload;
